/**
 * Custom JS overrides
 * Do not edit theme.js or vendor.min.js - put all custom logic here.
 * Use the Safe Init Pattern for all code.
 */

/* Mobile Bottom Nav Logic */
function debounce(fn, delay) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(...args), delay);
    };
}

const updateCartBadge = debounce(async () => {
    try {
        const response = await fetch('/cart.json');
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const cart = await response.json();
        const badge = document.querySelector('[data-cart-count]');
        if (badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'block' : 'none';
        }
        updateCtaHighlight(cart.item_count);
    } catch (error) {
        console.warn('Cart badge update failed:', error);
    }
}, 150);

function isCartPage() {
    if (window.themeVariables?.settings?.pageType === 'cart') return true;
    return /^\/cart\/?$/.test(window.location.pathname);
}

// Only fetch on back/forward navigation
window.addEventListener('pageshow', (event) => {
    const navEntry = performance.getEntriesByType('navigation')[0];

    if (isCartPage() && (event.persisted || navEntry?.type === 'back_forward')) {
        window.location.reload();
        return;
    }

    if (event.persisted) {
        updateCartBadge();
    } else {
        if (navEntry && navEntry.type === 'back_forward') {
            updateCartBadge();
        }
    }
});

// Toggle active state when cart drawer opens/closes
const cartButton = document.querySelector('[data-nav-item="cart"]');
const cartDrawer = document.getElementById('cart-drawer');

if (cartDrawer && cartButton) {
    const setCartActive = () => {
        cartButton.classList.toggle('is-active', cartDrawer.hasAttribute('open'));
    };
    setCartActive();
    cartDrawer.addEventListener('toggle', setCartActive);
}

// Toggle active state when menu drawer opens/closes
const menuButton = document.querySelector('[data-nav-item="menu"]');
const menuDrawer = document.getElementById('header-sidebar-menu');

if (menuDrawer && menuButton) {
    const setMenuActive = () => {
        menuButton.classList.toggle('is-active', menuDrawer.hasAttribute('open'));
    };
    setMenuActive();
    menuDrawer.addEventListener('toggle', setMenuActive);
}

// Scroll to Hide Logic (Spec)
let lastScrollY = window.scrollY;
let tunnelModeActive = sessionStorage.getItem('nav-tunnel-mode') === 'true';
const nav = document.querySelector('.mobile-bottom-nav');
const enableScrollHide = nav ? nav.dataset.scrollHide === 'true' : false;
const quizPath = nav ? nav.dataset.quizPath || '' : '';

function normalizePath(path) {
    return (path || '').replace(/\/+$/, '');
}

function isQuizPagePath() {
    if (!quizPath) return false;
    try {
        const configuredPath = normalizePath(new URL(quizPath, window.location.origin).pathname);
        const currentPath = normalizePath(window.location.pathname);
        return currentPath === configuredPath;
    } catch (error) {
        return normalizePath(window.location.pathname) === normalizePath(quizPath);
    }
}

if (nav && enableScrollHide) {
    window.addEventListener(
        'scroll',
        () => {
            if (tunnelModeActive) return;
            const currentScrollY = window.scrollY;

            // Hide on scroll down > 50px, Show on scroll up
            if (currentScrollY > lastScrollY && currentScrollY > 50) {
                nav.style.transform = 'translateY(100%)';
            } else {
                nav.style.transform = 'translateY(0)';
            }
            lastScrollY = currentScrollY;
        },
        { passive: true }
    );
}

// Dynamic CTA Logic
const defaultCta = nav ? nav.dataset.defaultCta : 'none';
const prioritizeCart = nav ? nav.dataset.ctaPrioritizeCart === 'true' : false;

function updateCtaHighlight(cartCount) {
    // Remove existing CTA class from all items
    document.querySelectorAll('.mobile-nav-item.is-cta').forEach((el) => el.classList.remove('is-cta'));

    // Determine which button should be CTA
    let ctaTarget = defaultCta;
    if (prioritizeCart && cartCount > 0) {
        ctaTarget = 'cart';
    }

    // Apply CTA class
    if (ctaTarget && ctaTarget !== 'none') {
        const ctaButton = document.querySelector(`[data-nav-item="${ctaTarget}"]`);
        if (ctaButton) {
            ctaButton.classList.add('is-cta');
        }
    }
}

// Initial CTA based on server-rendered cart count
const initialCartCount = parseInt(document.querySelector('[data-cart-count]')?.textContent || '0', 10);
updateCtaHighlight(initialCartCount);

// Cart events: single handler updates both badge and CTA
document.addEventListener('cart:refresh', updateCartBadge);
document.addEventListener('cart:change', updateCartBadge);

// Hub Page "Tunnel Mode" - Hide nav when quiz starts
document.addEventListener('hub:tunnel-mode', function () {
    if (nav && window.innerWidth <= 749) {
        nav.style.transform = 'translateY(100%)';
        tunnelModeActive = true;
        sessionStorage.setItem('nav-tunnel-mode', 'true');
    }
});

// Restore nav visibility when leaving tunnel
window.addEventListener('pageshow', function () {
    if (nav && sessionStorage.getItem('nav-tunnel-mode') === 'true') {
        // Check if we're on the configured quiz page - if not, restore nav
        const isQuizPage = isQuizPagePath();
        if (!isQuizPage) {
            nav.style.transform = 'translateY(0)';
            tunnelModeActive = false;
            sessionStorage.removeItem('nav-tunnel-mode');
        }
    }
});

/* =========================================================================
   Hub Hero — CTA scroll + chevron (Safe Init Pattern)
   ========================================================================= */

function initHubHero(root) {
    root = root || document;
    var heroes = root.querySelectorAll('.hub-hero');
    if (!heroes.length) return;

    heroes.forEach(function (hero) {
        if (hero.dataset.initialized === 'true') return;

        /* --- CTA: Smooth scroll + tunnel mode --- */
        var ctaWrapper = hero.querySelector('[data-hub-cta]');
        if (ctaWrapper) {
            var ctaButton = ctaWrapper.querySelector('a, button');
            if (ctaButton) {
                ctaButton.addEventListener('click', function (e) {
                    var href = ctaButton.getAttribute('href') || '';
                    var targetId = '';
                    if (href.indexOf('#') !== -1) {
                        targetId = href.split('#')[1];
                    }
                    if (targetId) {
                        e.preventDefault();
                        var el =
                            document.getElementById(targetId) ||
                            document.querySelector('[id*="' + targetId + '"]') ||
                            document.querySelector('[data-section-id*="' + targetId + '"]') ||
                            document.querySelector('.shopify-section--' + targetId);
                        if (el) {
                            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }
                    /* Tunnel mode for mobile */
                    var mobileNav = document.querySelector('.mobile-bottom-nav');
                    if (mobileNav && window.innerWidth <= 749) {
                        document.dispatchEvent(new CustomEvent('hub:tunnel-mode'));
                    }
                });
            }
        }

        /* --- Scroll chevron click --- */
        var chevron = hero.querySelector('[data-hub-scroll-chevron]');
        if (chevron) {
            chevron.addEventListener('click', function () {
                var heroSection = chevron.closest('.shopify-section');
                var nextSection = heroSection ? heroSection.nextElementSibling : null;
                if (nextSection) {
                    nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        }

        hero.dataset.initialized = 'true';
    });
}

document.addEventListener('DOMContentLoaded', function () { initHubHero(); });
document.addEventListener('shopify:section:load', function (e) { initHubHero(e.target); });

/* =========================================================================
   Checkbox Variant Picker (Safe Init Pattern)
   All values from data-* attributes — zero Liquid dependency.
   Scoped to wrapper for quick-buy / multi-product safety.
   ========================================================================= */

function initCheckboxVariantPicker(root) {
    root = root || document;
    var wrappers = root.querySelectorAll('.checkbox-variant-data');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
        // Idempotency: per-wrapper guard
        if (wrapper.dataset.initialized === 'true') return;
        wrapper.dataset.initialized = 'true';

        // Read IDs from data-* attributes
        var checkboxId = wrapper.dataset.checkboxId;
        var radio0Id = wrapper.dataset['radio-0Id'];
        var radio1Id = wrapper.dataset['radio-1Id'];

        var checkbox = document.getElementById(checkboxId);
        var variant0Radio = document.getElementById(radio0Id);
        var variant1Radio = document.getElementById(radio1Id);

        if (!checkbox || !variant0Radio || !variant1Radio) {
            console.error('Checkbox variant picker: Required elements not found', {
                checkboxId: checkboxId,
                radio0Id: radio0Id,
                radio1Id: radio1Id,
                checkboxFound: !!checkbox,
                radio0Found: !!variant0Radio,
                radio1Found: !!variant1Radio,
                keys: Object.keys(wrapper.dataset)
            });
            return;
        }

        if (radio0Id === radio1Id) {
            console.error('Checkbox variant picker: CRITICAL - Radio IDs are identical. Liquid logic may be failing to resolve unique IDs.', {
                radio0Id: radio0Id
            });
        }

        // Read config from data-* attributes
        var hasCustomText = wrapper.dataset.hasCustomText === 'true';
        var showPopup = wrapper.dataset.showPopup === 'true';
        var variant0Price = wrapper.dataset['variant-0Price'] || '';
        var variant1Price = wrapper.dataset['variant-1Price'] || '';

        // --- Popup setup (only if enabled) ---
        var popup = null;
        var popupTimeout = null;

        if (showPopup) {
            var popupId = checkboxId + '-popup';
            popup = document.getElementById(popupId);

            if (!popup) {
                popup = document.createElement('div');
                popup.id = popupId;

                // Convert hex color to rgba with opacity
                var bgColor = wrapper.dataset.popupBg || '#000000';
                var bgOpacityVal = (parseInt(wrapper.dataset.popupOpacity, 10) || 90) / 100;
                var bgRgba = bgColor.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
                var background = bgRgba
                    ? 'rgba(' + parseInt(bgRgba[1], 16) + ', ' + parseInt(bgRgba[2], 16) + ', ' + parseInt(bgRgba[3], 16) + ', ' + bgOpacityVal + ')'
                    : 'rgba(0, 0, 0, ' + bgOpacityVal + ')';

                var padding = parseInt(wrapper.dataset.popupPadding, 10) || 16;
                var radius = parseInt(wrapper.dataset.popupRadius, 10) || 8;
                var fontSize = parseInt(wrapper.dataset.popupFontSize, 10) || 16;
                var textColor = wrapper.dataset.popupColor || '#FFFFFF';

                popup.style.cssText =
                    'position: fixed;' +
                    'bottom: 30px;' +
                    'left: 50%;' +
                    'transform: translateX(-50%);' +
                    'background: ' + background + ';' +
                    'color: ' + textColor + ';' +
                    'padding: ' + padding + 'px ' + Math.round(padding * 1.5) + 'px;' +
                    'border-radius: ' + radius + 'px;' +
                    'font-size: ' + fontSize + 'px;' +
                    'line-height: 1.5;' +
                    'z-index: 9999;' +
                    'opacity: 0;' +
                    'visibility: hidden;' +
                    'transition: opacity 0.3s ease, visibility 0.3s ease;' +
                    'max-width: 90%;' +
                    'text-align: center;' +
                    'box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);';

                document.body.appendChild(popup);
            }
        }

        var popupDuration = (parseInt(wrapper.dataset.popupDuration, 10) || 3) * 1000;
        var popupTextChecked = wrapper.dataset.popupTextChecked || '';
        var popupTextUnchecked = wrapper.dataset.popupTextUnchecked || '';

        function formatText(text) {
            if (!text) return '';
            var parts = text.split('*');
            if (parts.length === 3) {
                return parts[0] + '<em>' + parts[1] + '</em>' + parts[2];
            }
            return text;
        }

        function triggerPopup(text) {
            if (!text || !popup) return;
            if (popupTimeout) clearTimeout(popupTimeout);

            popup.innerHTML = formatText(text);
            popup.offsetHeight; // Force reflow
            popup.style.opacity = '1';
            popup.style.visibility = 'visible';

            popupTimeout = setTimeout(function () {
                popup.style.opacity = '0';
                popup.style.visibility = 'hidden';
            }, popupDuration);
        }

        // --- Checkbox change handler ---
        if (!hasCustomText) {
            // Default mode: update label and price text
            var labelSpan = wrapper.querySelector('.checkbox-variant-label');
            var priceSpan = wrapper.querySelector('.checkbox-variant-price');

            if (labelSpan && priceSpan) {
                var variant0Title = labelSpan.getAttribute('data-variant-0-title') || '';
                var variant1Title = labelSpan.getAttribute('data-variant-1-title') || '';

                checkbox.addEventListener('change', function () {
                    if (this.checked) {
                        variant1Radio.checked = true;
                        labelSpan.textContent = variant1Title;
                        priceSpan.textContent = variant1Price;
                        if (showPopup) triggerPopup(popupTextChecked);
                    } else {
                        variant0Radio.checked = true;
                        labelSpan.textContent = variant0Title;
                        priceSpan.textContent = variant0Price;
                        if (showPopup && popupTextUnchecked) triggerPopup(popupTextUnchecked);
                    }

                    // Critical: dispatch change on radio for Impact's <variant-picker> sync
                    var selectedRadio = this.checked ? variant1Radio : variant0Radio;
                    selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
                });
            }
        } else {
            // Custom text mode: just toggle radio, no label/price update
            checkbox.addEventListener('change', function () {
                if (this.checked) {
                    variant1Radio.checked = true;
                    variant1Radio.dispatchEvent(new Event('change', { bubbles: true }));
                    if (showPopup) triggerPopup(popupTextChecked);
                } else {
                    variant0Radio.checked = true;
                    variant0Radio.dispatchEvent(new Event('change', { bubbles: true }));
                    if (showPopup && popupTextUnchecked) triggerPopup(popupTextUnchecked);
                }
            });
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCheckboxVariantPicker(); });
} else {
    initCheckboxVariantPicker();
}
document.addEventListener('shopify:section:load', function (e) { initCheckboxVariantPicker(e.target); });

/* =========================================================================
   Video Gallery — Impact-correct controller pattern (v2)
   Controller registry with destroy() for Theme Editor teardown.
   FocusTrap from Impact vendor with graceful tab-trap fallback.
   Dynamic gap via getComputedStyle — no hardcoded pixel values.
   ========================================================================= */

var _vgfControllers = new Map();

function destroyVideoGallery(root) {
    root = root || document;
    root.querySelectorAll('.vgf-gallery').forEach(function (wrapper) {
        var id = wrapper.id;
        if (id && _vgfControllers.has(id)) {
            _vgfControllers.get(id).destroy();
            _vgfControllers.delete(id);
        }
        delete wrapper.dataset.initialized;
    });
}

function initVideoGallery(root) {
    root = root || document;
    root.querySelectorAll('.vgf-gallery').forEach(function (wrapper) {
        if (wrapper.dataset.initialized === 'true') return;
        wrapper.dataset.initialized = 'true';
        var ctrl = _createVgfController(wrapper);
        if (ctrl && wrapper.id) {
            _vgfControllers.set(wrapper.id, ctrl);
        }
    });
}

function _createVgfController(wrapper) {
    var layoutMode = wrapper.dataset.layout || 'grid';
    var enableTikTok = wrapper.dataset.tiktok === 'true';
    var enableAutoplay = wrapper.dataset.autoplay === 'true';
    var autoplaySpeed = (parseInt(wrapper.dataset.autoplaySpeed, 10) || 4) * 1000;

    var modal = wrapper.querySelector('.vgf-modal');
    var slider = wrapper.querySelector('.vgf-grid');
    var cards = wrapper.querySelectorAll('.vgf-video-card');

    if (!modal || cards.length === 0) return null;

    var modalVideo = modal.querySelector('.vgf-modal-video');
    var closeBtn = modal.querySelector('.vgf-close-btn');
    var overlayEl = modal.querySelector('.vgf-modal-overlay');
    var modalPrevBtn = modal.querySelector('.vgf-modal-arrow-prev');
    var modalNextBtn = modal.querySelector('.vgf-modal-arrow-next');

    var lastFocused = null;
    var currentIndex = 0;
    var autoplayInterval = null;
    var focusTrap = null;
    var ioObserver = null;
    var autoplayViewportObserver = null;
    var isSectionVisible = false;

    // Listener registry for clean teardown
    var _bound = [];
    function on(el, type, fn, opts) {
        el.addEventListener(type, fn, opts);
        _bound.push([el, type, fn, opts]);
    }
    function offAll() {
        _bound.forEach(function (b) {
            try { b[0].removeEventListener(b[1], b[2], b[3]); } catch (e) { }
        });
        _bound = [];
    }

    // --- Utilities ---

    function getGap() {
        if (!slider) return 0;
        var g = parseFloat(window.getComputedStyle(slider).columnGap);
        return isNaN(g) ? 0 : g;
    }

    function isSliderActive() {
        return layoutMode === 'slider' ||
            (layoutMode === 'grid_slider' && window.innerWidth <= 768);
    }

    function shouldRunAutoplay() {
        return enableAutoplay &&
            !!slider &&
            isSliderActive() &&
            isSectionVisible &&
            !document.hidden &&
            !modal.classList.contains('active');
    }

    function stopAutoplay() {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
    }

    function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
    }

    function startAutoplay() {
        if (!shouldRunAutoplay() || autoplayInterval) return;

        // Smoothly fade out/in slider when resetting to the beginning instead of 
        // quickly scrolling back through all videos backwards.
        autoplayInterval = setInterval(function () {
            var gap = getGap();
            var lastCard = cards[cards.length - 1];
            var atEnd = false;

            if (lastCard) {
                // Check if the last card is visible in (or past) the viewport.
                // This works with both start and center snap alignment.
                var lastRect = lastCard.getBoundingClientRect();
                var sliderRect = slider.getBoundingClientRect();
                atEnd = lastRect.left < sliderRect.right;
            } else {
                // Fallback: raw scroll math
                atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 10;
            }

            if (atEnd) {
                // At the last card: Fade out, jump to start, fade in.
                slider.style.transition = 'opacity 0.4s ease';
                slider.style.opacity = '0';

                setTimeout(function () {
                    slider.scrollTo({ left: 0, behavior: 'auto' });
                    slider.style.opacity = '1';
                    setTimeout(function () {
                        slider.style.transition = '';
                    }, 400); // clear transition
                }, 400); // wait for fade out
            } else {
                // Otherwise scroll to next card smoothly
                var card = slider.querySelector('.vgf-video-card');
                if (card) {
                    slider.scrollBy({ left: card.getBoundingClientRect().width + gap, behavior: 'smooth' });
                }
            }
        }, autoplaySpeed);
    }

    // --- FocusTrap from Impact vendor (graceful fallback to built-in tab-trap) ---
    // vendor is already loaded as a module; dynamic import resolves from the module registry.
    import('vendor').then(function (mod) {
        // Maestrooo docs: `import FocusTrap from 'vendor'` → default export
        var FT = mod.default || mod.FocusTrap;
        if (FT && typeof FT.createFocusTrap === 'function') {
            focusTrap = FT.createFocusTrap(modal, {
                initialFocus: function () { return closeBtn; },
                allowOutsideClick: true,
                escapeDeactivates: false  // we handle Escape ourselves (also drives arrow-key nav)
            });
        }
    }).catch(function () { /* vendor not available — tab-trap fallback stays active */ });

    // --- Modal ---

    function openModal(card) {
        if (modal.classList.contains('active')) return;
        var url = card.getAttribute('data-video-url');
        var index = parseInt(card.getAttribute('data-video-index'), 10);
        if (!url) return;

        currentIndex = isNaN(index) ? 0 : index;
        var title = card.getAttribute('data-video-title') || '';
        modal.setAttribute('aria-label', title ? 'Video: ' + title : 'Video player');
        lastFocused = document.activeElement;

        var thumb = card.querySelector('.vgf-thumbnail');
        if (thumb && thumb.src) modalVideo.poster = thumb.src;
        modalVideo.src = url;
        modal.classList.add('active');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.setProperty('--vgf-scroll-y', window.scrollY);
        document.body.classList.add('vgf-modal-open');
        stopAutoplay();

        if (focusTrap) {
            focusTrap.activate();
        } else {
            setTimeout(function () { closeBtn.focus(); }, 10);
        }

        setTimeout(function () {
            var p = modalVideo.play();
            if (p && p.catch) p.catch(function () { });
        }, 50);

        document.addEventListener('keydown', handleKeyDown);
    }

    function closeModal() {
        if (!modal.classList.contains('active')) return;
        var scrollY = document.documentElement.style.getPropertyValue('--vgf-scroll-y');
        modal.classList.remove('active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('vgf-modal-open');
        if (scrollY) {
            window.scrollTo(0, parseInt(scrollY, 10));
        }
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.removeAttribute('poster');
        modalVideo.load();

        if (focusTrap) focusTrap.deactivate({ returnFocus: false });
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
        document.removeEventListener('keydown', handleKeyDown);

        if (!autoplayInterval) startAutoplay();
    }

    function navigateVideo(dir) {
        var n = dir === 'next'
            ? (currentIndex + 1) % cards.length
            : (currentIndex - 1 + cards.length) % cards.length;
        var newCard = cards[n];
        if (!newCard) return;
        var url = newCard.getAttribute('data-video-url');
        if (!url) return;
        currentIndex = n;
        var thumb = newCard.querySelector('.vgf-thumbnail');
        modalVideo.poster = (thumb && thumb.src) ? thumb.src : '';
        modalVideo.src = url;
        var t = newCard.getAttribute('data-video-title') || '';
        modal.setAttribute('aria-label', t ? 'Video: ' + t : 'Video player');
        var p = modalVideo.play();
        if (p && p.catch) p.catch(function () { });
    }

    // Tab-trap fallback (used when FocusTrap from vendor is unavailable)
    function tabTrap(e) {
        var focusables = Array.prototype.slice.call(modal.querySelectorAll(
            'button:not([disabled]), video, [href], input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), ' +
            '[tabindex]:not([tabindex="-1"])'
        ));
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
        }
    }

    function handleKeyDown(e) {
        if (e.key === 'Escape') { closeModal(); return; }
        if (e.key === 'ArrowLeft') { e.preventDefault(); navigateVideo('prev'); return; }
        if (e.key === 'ArrowRight') { e.preventDefault(); navigateVideo('next'); return; }
        if (e.key === 'Tab' && !focusTrap) tabTrap(e);
    }

    // --- Bind events ---

    cards.forEach(function (card) {
        on(card, 'click', function () { openModal(this); });
    });

    on(closeBtn, 'click', closeModal);
    on(overlayEl, 'click', closeModal);
    if (modalPrevBtn) on(modalPrevBtn, 'click', function () { navigateVideo('prev'); });
    if (modalNextBtn) on(modalNextBtn, 'click', function () { navigateVideo('next'); });

    // Swipe-to-close on modal overlay/video
    var touchStartY = 0;
    on(modal, 'touchstart', function (e) {
        touchStartY = e.touches[0].clientY;
    }, { passive: true });
    on(modal, 'touchmove', function (e) {
        var touchEndY = e.touches[0].clientY;
        if (touchEndY - touchStartY > 60) {
            closeModal();
        }
    }, { passive: true });

    // --- Carousel arrows & dots ---

    if (layoutMode === 'slider' || layoutMode === 'grid_slider') {
        var arrowPrev = wrapper.querySelector('.vgf-arrow-prev');
        var arrowNext = wrapper.querySelector('.vgf-arrow-next');
        var dotsContainer = wrapper.querySelector('.vgf-dots');
        var dots = [];

        if (dotsContainer) {
            cards.forEach(function (_, i) {
                var dot = document.createElement('div');
                dot.className = 'vgf-dot' + (i === 0 ? ' active' : '');
                dot.setAttribute('aria-label', 'Go to video ' + (i + 1));
                on(dot, 'click', function () {
                    var card = cards[i];
                    if (card && slider) {
                        slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
                    }
                });
                dotsContainer.appendChild(dot);
                dots.push(dot);
            });
        }

        function updateSliderState() {
            if (!slider) return;
            if (!isSliderActive()) {
                if (arrowPrev) arrowPrev.classList.remove('visible');
                if (arrowNext) arrowNext.classList.remove('visible');
                return;
            }
            var sl = slider.scrollLeft;
            var max = slider.scrollWidth - slider.clientWidth;
            if (arrowPrev) arrowPrev.classList.toggle('visible', sl > 5);
            if (arrowNext) arrowNext.classList.toggle('visible', sl < max - 5);

            if (dots.length > 0) {
                var cardWidth = cards[0] ? cards[0].getBoundingClientRect().width + getGap() : 1;
                var activeIndex = Math.round(sl / cardWidth);
                if (activeIndex < 0) activeIndex = 0;
                if (activeIndex >= dots.length) activeIndex = dots.length - 1;

                dots.forEach(function (dot, i) {
                    dot.classList.toggle('active', i === activeIndex);
                });
            }
        }

        function scrollDir(dir) {
            if (!slider) return;
            var card = slider.querySelector('.vgf-video-card');
            if (!card) return;
            var amt = card.getBoundingClientRect().width + getGap();
            slider.scrollBy({ left: dir === 'prev' ? -amt : amt, behavior: 'smooth' });
            if (enableAutoplay) resetAutoplay();
        }

        if (arrowPrev || arrowNext || dots.length > 0) {
            if (arrowPrev) on(arrowPrev, 'click', function () { scrollDir('prev'); });
            if (arrowNext) on(arrowNext, 'click', function () { scrollDir('next'); });
            on(slider, 'scroll', updateSliderState, { passive: true });
            on(window, 'resize', updateSliderState);
            setTimeout(updateSliderState, 100);
        }
    }

    // --- TikTok mode ---

    if (enableTikTok && window.innerWidth <= 768) {
        var ratioMap = new Map();

        function onIntersect(entries) {
            entries.forEach(function (e) { ratioMap.set(e.target, e.intersectionRatio); });
            var best = null, top = 0;
            cards.forEach(function (c) {
                var r = ratioMap.get(c) || 0;
                if (r > top && r > 0.5) { top = r; best = c; }
            });
            cards.forEach(function (c) {
                c.classList.toggle('vgf-in-view', c === best);
                c.classList.toggle('vgf-out-of-view', c !== best);
            });
        }

        ioObserver = new IntersectionObserver(onIntersect, {
            threshold: [0, 0.25, 0.5, 0.75, 1.0]
        });
        cards.forEach(function (c) { ioObserver.observe(c); });

        if (modalVideo) {
            on(modalVideo, 'click', function () {
                modalVideo.paused ? modalVideo.play() : modalVideo.pause();
            });
        }
    }

    // --- Autoplay ---

    if (enableAutoplay) {
        if ('IntersectionObserver' in window) {
            autoplayViewportObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.target === wrapper) {
                        isSectionVisible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
                    }
                });

                shouldRunAutoplay() ? (autoplayInterval || startAutoplay()) : stopAutoplay();
            }, {
                threshold: [0, 0.2, 0.35, 0.5],
                rootMargin: '0px 0px -10% 0px'
            });

            autoplayViewportObserver.observe(wrapper);
        } else {
            isSectionVisible = true;
        }

        if (isSliderActive()) {
            on(slider, 'touchstart', function () {
                stopAutoplay();
            }, { passive: true });
            on(slider, 'touchend', function () {
                resetAutoplay();
            }, { passive: true });
            on(slider, 'mousedown', stopAutoplay);
            on(slider, 'mouseup', function () {
                resetAutoplay();
            });
        }

        on(document, 'visibilitychange', function () {
            shouldRunAutoplay() ? (autoplayInterval || startAutoplay()) : stopAutoplay();
        });

        on(window, 'resize', function () {
            shouldRunAutoplay() ? (autoplayInterval || startAutoplay()) : stopAutoplay();
        });

        shouldRunAutoplay() ? (autoplayInterval || startAutoplay()) : stopAutoplay();
    }

    // --- Destroy (called on shopify:section:unload) ---

    function destroy() {
        stopAutoplay();
        if (focusTrap) { try { focusTrap.deactivate(); } catch (e) { } focusTrap = null; }
        if (ioObserver) { ioObserver.disconnect(); ioObserver = null; }
        if (autoplayViewportObserver) { autoplayViewportObserver.disconnect(); autoplayViewportObserver = null; }
        document.removeEventListener('keydown', handleKeyDown);
        document.body.classList.remove('vgf-modal-open');
        offAll();
    }

    return { destroy: destroy };
}

document.addEventListener('DOMContentLoaded', function () { initVideoGallery(); });
document.addEventListener('shopify:section:load', function (e) { initVideoGallery(e.target); });
document.addEventListener('shopify:section:unload', function (e) { destroyVideoGallery(e.target); });

/* ==========================================================================
   ARTICLE TABLE OF CONTENTS BUILDER
   Scans .prose for h2/h3, assigns slug IDs, builds the #article-toc-list,
   then reveals the nav. Highlights the active heading on scroll.

   NOTE: custom.js is loaded as type="module" defer — DOMContentLoaded has
   already fired by the time this module executes, so we call directly.
   Attached to window for Theme Editor reinit.
   ========================================================================== */

function initArticleTOC() {
    const tocNav = document.getElementById('article-toc');
    const tocList = document.getElementById('article-toc-list');
    const articleContent = tocNav ? tocNav.closest('.article-content') : null;
    const prose = articleContent ? articleContent.querySelector('.prose') : null;

    if (!prose || !tocNav || !tocList) return;

    // Collect h2 and h3 headings
    const headings = Array.from(prose.querySelectorAll('h2, h3'));
    if (headings.length < 2) return; // not worth showing

    // Slug helper: turns a heading text into a URL-safe id
    function toSlug(text) {
        return text
            .toLowerCase()
            .replace(/[^\p{L}\p{N}\s-]/gu, '')
            .trim()
            .replace(/[\s_-]+/g, '-');
    }

    // Assign IDs to headings (avoid duplicates)
    const usedIds = {};
    headings.forEach(function (h) {
        if (!h.id) {
            let slug = toSlug(h.innerText || h.textContent);
            if (!slug) slug = 'heading';
            if (usedIds[slug] !== undefined) {
                usedIds[slug]++;
                slug = slug + '-' + usedIds[slug];
            } else {
                usedIds[slug] = 0;
            }
            h.id = slug;
        }
    });

    // Build list items
    const fragment = document.createDocumentFragment();
    headings.forEach(function (h) {
        const level = parseInt(h.tagName[1], 10); // 2 or 3
        const li = document.createElement('li');
        li.setAttribute('data-level', level);
        li.setAttribute('data-target', h.id);

        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.innerText || h.textContent;

        // Smooth scroll without polluting the URL history on every click
        a.addEventListener('click', function (e) {
            e.preventDefault();
            h.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // Update URL hash quietly
            history.replaceState(null, '', '#' + h.id);
        });

        li.appendChild(a);
        fragment.appendChild(li);
    });

    tocList.appendChild(fragment);

    // Show the nav (it is hidden by default)
    tocNav.removeAttribute('hidden');

    // Active heading highlight via IntersectionObserver
    if (!('IntersectionObserver' in window)) return;

    const listItems = Array.from(tocList.querySelectorAll('li[data-target]'));

    const observer = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const id = entry.target.id;
                    listItems.forEach(function (li) {
                        li.classList.toggle('is-active', li.getAttribute('data-target') === id);
                    });
                }
            });
        },
        {
            rootMargin: '-10% 0px -80% 0px', // trigger when heading is near the top of viewport
            threshold: 0
        }
    );

    headings.forEach(function (h) { observer.observe(h); });
}

// Run on initial load
initArticleTOC();

// Reinitialize when section is reloaded in the Theme Editor
document.addEventListener('shopify:section:load', function () {
    var list = document.getElementById('article-toc-list');
    if (list) { list.innerHTML = ''; }
    var nav = document.getElementById('article-toc');
    if (nav) { nav.setAttribute('hidden', ''); }
    initArticleTOC();
});
